import { inject, Injectable } from '@angular/core'
import { AssistantFeedback } from '../../../models/assistantFeedback'
import { FeathersService } from '../../feathers.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class AssistantFeedbackService {
  private feathers = inject(FeathersService)

  getByAssignmentIds(assignmentIds: number[]): Observable<AssistantFeedback[]> {
    return this.feathers
      .find(AssistantFeedback, { assignmentIds })
      .pipe(map((feedbacks) => feedbacks.filter((feedback) => assignmentIds.includes(feedback.assignmentId))))
  }

  removeById(id: number) {
    return this.feathers.removeById(AssistantFeedback.serviceName, id)
  }
}
